import { validate as uuidValidate } from 'uuid'

export function validatePhone(phone: string): boolean {
  const phoneDigits = phone.replace(/\D/g, '')
  return phoneDigits.length === 10
}

export function validateCode(code: string): boolean {
  return code.length === 6
}

export function validateEmail(email: string): boolean {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.[^\s@]{2,}$/
  return emailRegex.test(email)
}

export function validateName(name: string): boolean {
  return name.length > 0
}

export function validateGender(gender: string): boolean {
  return ['male', 'female', 'non - binary', 'prefer not to say'].includes(
    gender.toLowerCase(),
  )
}

export function validateDate(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date)
}

export function validateUuid(uuid: string): boolean {
  return uuidValidate(uuid)
}
